export default __webpack_public_path__ + "static/media/press-09.7f3b8304.jpg";